"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var getMargin = function getMargin(props) {
  if (props.margin === undefined || props.margin === null) return "0 -" + props.theme.default.padding + "px";
  if (!props.margin) return 0;
  if (typeof props.margin === 'string') return props.margin;
  if (typeof props.margin === 'number') return props.margin + "px";
  return "0 -" + props.theme.default.padding + "px";
};

exports.Row = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: ", ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  margin: ", ";\n"], ["\n  flex: ", ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  margin: ", ";\n"])), function (_a) {
  var flex = _a.flex;
  return !flex ? '0 0 auto' : typeof flex === 'boolean' ? 1 : flex;
}, function (_a) {
  var wrap = _a.wrap;
  return !wrap ? 'unset' : typeof wrap === 'boolean' ? 'wrap' : wrap;
}, function (_a) {
  var alignItems = _a.alignItems,
      align = _a.align;
  return alignItems || align || 'unset';
}, function (_a) {
  var justify = _a.justify;
  return justify || 'unset';
}, getMargin);
var templateObject_1;